<template>
  <div class="pt-3">
    <vs-table
      :max-items="5"
      pagination
      search
      :data="transactions"
      @selected="handelSelected"
    >
      <template slot="header">
        <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
          {{ $t("customers.label.adjustment") }}
        </div>
        <!-- ADD NEW -->
        <div class="mr-2 mb-1 order-1">
          <vs-button
            color="primary"
            icon-pack="feather"
            icon="icon-sliders"
            class="truncate"
            @click="AdjustmentPopup = true"
            size="small"
            >{{ $t("button.adjustment") }}</vs-button
          >
        </div>
      </template>
      <template slot="thead">
        <vs-th>{{ $t("customers.label.user_name") }}</vs-th>
        <vs-th>{{ $t("customers.label.transaction_id") }}</vs-th>
        <vs-th>{{ $t("customers.label.transaction_date") }}</vs-th>
        <vs-th>{{ $t("customers.label.transaction_type") }}</vs-th>
        <vs-th>{{ $t("customers.label.category") }}</vs-th>
        <vs-th>{{ $t("customers.label.credit_amount") }}</vs-th>
        <vs-th>{{ $t("customers.label.debit_amount") }}</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr
          :key="index"
          :data="transaction"
          v-for="(transaction, index) in data"
        >
          <vs-td :data="transaction.userName">{{ transaction.userName }}</vs-td>
          <vs-td :data="transaction.transactionId">{{
            transaction.transactionId
          }}</vs-td>
          <vs-td :data="getDate(transaction.transDate)">{{
            getDate(transaction.transDate)
          }}</vs-td>

          <vs-td :data="transaction.transactionType">{{
            transaction.transactionType
          }}</vs-td>
          <vs-td :data="transaction.transactionCategory">{{
            transaction.transactionCategory
          }}</vs-td>

          <vs-td :data="transaction.creditAmount">{{
            transaction.creditAmount
          }}</vs-td>
          <vs-td :data="transaction.amount">{{ transaction.amount }}</vs-td>
          <!-- <vs-td>
                      <feather-icon
                        title="Print Invocie"
                        icon="DownloadIcon"
                        class="mr-1"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      />
                      <feather-icon
                        title="cancle Payment"
                        icon="XIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      />
                    </vs-td> -->
        </vs-tr>
      </template>
    </vs-table>
    <div class="centerx">
      <vs-popup
        :title="$t('customers.label.Create Adjustment')"
        :active.sync="AdjustmentPopup"
        class="popup-close"
      >
        <form>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.adjustment_date")
                  }}<span class="required"> *</span></small
                >
                <datepicker
                  :placeholder="$t('customers.label.SelectDate')"
                  v-model="adjustments.date"
                  class="mb-2 font-semibold"
                />
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.adjustment_code")
                  }}<span class="required"> *</span></small
                >
                <v-select
                  label="adjustmentCode"
                  v-model="adjustments.adjustmentCode"
                  :options="adjustmentDatas.data"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(adjustmentCode) => adjustmentCode.id"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                />
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <vs-input
                :label="$t('customers.label.adjustment_amount')"
                type="text"
                class="w-full font-semibold mb-2 starlabel"
                v-model="adjustments.adjustmentAmount"
              />
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.adjustment_type")
                  }}<span class="required"> *</span></small
                >
                <v-select
                  label="discountType"
                  :options="adjustmentDatas.discountOptions"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  v-model="adjustments.discount"
                  :reduce="(discountType) => discountType.discountType"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                />
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.notes")
                  }}<span class="required"> *</span></small
                >
                <vs-textarea class="w-full mb-2" v-model="adjustments.notes" />
              </div>
            </div>
          </div>
          <div style="height: 20px"></div>
          <div class="center">
            <span class="ml-1 mr-1">
              <vs-button
                @click="addAdjustment"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("customers.label.submit") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 40px"></div>
        </form>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { quillEditor } from "vue-quill-editor";
import vSelect from "vue-select";
import moment from "moment";
import { BUCKET_BASE_URL } from "@/http/index";
import { mapState } from "vuex";
const adjustmentObj = {
  date: moment().format("DD MMMM YYYY"),
  adjustmentCode: "",
  discount: "",
  notes: "",
  adjustmentAmount: "",
};
export default {
  props: ["clientId"],
  data() {
    return {
      switch1: true,
      serviceOrder: [],
      identifier: false,
      additionalInfo: false,
      documentsUploads: false,
      creditCardDetails: false,
      adjustment2: false,
      cancelRemarkPopup: false,
      downloadDoc: false,
      cancelremark: "",
      transactionId: "",
      adjustment: { ...adjustmentObj },
      AdjustmentPopup: false,
      activeTab: 0,
      csvPdf: {
        format: "",
        startDate: moment().subtract(15, "d").format("DD MMMM YYYY"),
        endDate: moment().subtract(0, "d").format("DD MMMM YYYY"),
      },
      adjustments: {
        ...adjustmentObj,
      },
      format: ["csv", "pdf"],
    };
  },
  components: {
    quillEditor,
    Datepicker,
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    transactions() {
      return this.$store.getters["customer/getTransactionDetails"];
    },
    getAdjustments() {
      return this.$store.getters["customer/getAdjustmentsTemplate"];
    },
    adjustmentDatas() {
      return this.$store.getters["entity/getAdjustmentsTemplate"];
    },
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    async getTransactions(params) {
      try {
        //const resp = await getTransactionDetails(params, this.clientId);
        this.$store.dispatch("customer/setTransactionDetails", {
          params: params,
          clientId: this.clientId,
        });
      } catch (e) {
        console.log(
          "Something went wrong while retrieving transactions details: ",
          e
        );
      }
    },
    async adjustmentTemplate() {
      try {
        await this.$store.dispatch("entity/setAdjustmentsTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async addAdjustment() {
      if (
        !this.adjustments.adjustmentCode ||
        !this.adjustments.adjustmentAmount ||
        !this.adjustments.discount ||
        !this.adjustments.notes ||
        !this.adjustments.date
      ) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        try {
          const adjustmentData = {
            adjustment_type: this.adjustments.discount,
            withtax: false,
            amount_paid: this.adjustments.adjustmentAmount,
            adjustment_code: this.adjustments.adjustmentCode,
            Remarks: this.adjustments.notes,
            locale: "en",
            dateFormat: "dd MMMM yyyy",
            adjustment_date: this.adjustments.date,
            billpoId: null,
          };

          await this.$store.dispatch("customer/createAdjustmentAction", {
            id: this.clientId,
            data: adjustmentData,
          });
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Adjustment Done Successfully!",
            type: "success",
          });
          this.adjustments = { ...adjustmentObj };
          this.AdjustmentPopup = false;
          this.$emit("refreshPage");
        } catch (e) {
          this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
            "The parameter",
            ""
          );
          this.warningPopup = true;
          this.errors = e.message.errors;
        }
      }
    },

    async addDocument() {
      try {
        const fromDate = moment(this.csvPdf.startDate).format("DD-MM-YYYY");
        const toDate = moment(this.csvPdf.endDate).format("DD-MM-YYYY");

        window.open(
          BUCKET_BASE_URL +
            "/financialTransactions/download/" +
            this.clientId +
            `?downloadType=${this.csvPdf.format}&fromDate=1690828200000&toDate=1693491630929&tenantIdentifier=default`
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    printPayment(type, id) {
      window.open(
        BUCKET_BASE_URL +
          "/billmaster/" +
          type.toLowerCase() +
          "/" +
          this.clientId +
          "/" +
          id +
          "?email=false&tenantIdentifier=default"
      );
    },
    async paymentReversal() {
      try {
        const cancelRemarkObj = {
          cancelRemark: this.cancelremark,
          clientPoId: 0,
        };
        await this.$store.dispatch("customerPayment/cancelPaymentAction", {
          id: this.transactionId,
          data: cancelRemarkObj,
        });

        this.cancelremark = "";
        this.cancelRemarkPopup = false;
        this.getTransactions();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    handelSelected(item) {
      this.$router.push(
        `/viewfinancialtran/${item.transactionId}/${this.clientId}`
      );
    },
  },
  mounted() {
    this.getTransactions({});

    this.adjustmentTemplate();
  },
  watch: {
    activeTab(newValue) {
      if (newValue === 0) this.getTransactions({});
      else if (newValue === 1) this.getTransactions({ type: "INVOICE" });
      else if (newValue === 2) this.getTransactions({ type: "ADJUSTMENT" });
      else if (newValue === 3)
        this.getTransactions({ type: "JOURNAL+VOUCHER" });
      else if (newValue === 4)
        this.getTransactions({ type: "DEPOSIT%26REFUND" });
    },
  },
};
</script>
<style lang="scss" scoped>
.vs-tabs--ul {
  width: 60%;
}
.my-search-box {
  .vs-table--search-input {
    max-width: 150px;
    height: 2.4rem;
  }
  .vs-table--search {
    margin-top: 0;
  }
}
.tab-text {
  position: relative;
  top: -4.3rem;
  left: 1rem;
  padding-right: 2rem;

  overflow: visible;
}
::v-deep .con-vs-tabs {
  background: transparent !important;
}
::v-deep .con-vs-tabs .con-slot-tabs {
  overflow: visible;
}
</style>
